// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_Lm7","cls2":"ReferenceCard-cls2_vts ReferenceCard-cls1_Lm7"};